import cs from './cs/cs';
import en from './en/en';

export default {
    cs,
    en,
};
